import { API, get } from "../../config";

export const getTrustDetail = async (trustId) => {
  try {
    const { data } = await get(`${API.TRUST_DETAILS}/` + trustId);
    return data.data;
  } catch (e) {
    return null;
  }
};

export const getTrustPopupDetail = async (trustId, isRecentActivity) => {
  try {
    if (isRecentActivity) {
      const { data } = await get(`${API.TRUST_DETAILS}/${trustId}`);
      return data.data;
    } else {
      const { data } = await get(`${API.TRUST_DETAILS}/${trustId}`);
      return data.data;
    }
  } catch (error) {
    return null;
  }
};
